






import { Component, Vue, Inject, Watch } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import HeadquarterDetail from '@/views/headquarters/headquarter/HeadquarterDetail.vue';
import store, { State } from '@/store';
import { Headquarter } from '@/data/models/headquarter.model';

@Component({
	components: {
		HeadquarterDetail
	},
})
export default class Sede extends Vue {
    @Inject('CrudService') crudService!: CrudService<Headquarter>;
    
    sede: Headquarter | null = null;

    refresh: number = 1;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.refresh++;
	}

}
